var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM.25 11C.25 5.063 5.063.25 11 .25S21.75 5.063 21.75 11 16.937 21.75 11 21.75.25 16.937.25 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.252 2a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .71.988 27.674 27.674 0 0 0 0 17.524.75.75 0 0 1-.71.988h-1a.75.75 0 0 1-.022-1.5 29.175 29.175 0 0 1 0-16.5.75.75 0 0 1-.728-.75ZM13.763 1.289a.75.75 0 0 1 .949.474 29.173 29.173 0 0 1 0 18.475.75.75 0 1 1-1.423-.475 27.674 27.674 0 0 0 0-17.525.75.75 0 0 1 .474-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.562 13.392a.75.75 0 0 1 .676-.103 27.674 27.674 0 0 0 17.524 0 .75.75 0 0 1 .988.711v1a.75.75 0 0 1-1.5.022 29.177 29.177 0 0 1-16.5 0A.75.75 0 0 1 1.25 15v-1a.75.75 0 0 1 .312-.608ZM19.763 8.711a27.674 27.674 0 0 0-17.525 0 .75.75 0 0 1-.475-1.422 29.173 29.173 0 0 1 18.475 0 .75.75 0 1 1-.475 1.422Z"
  }))));
};
export default SvgGlobe;